<button class="msw-fab" (click)="open = !open" type="button">Mock setup</button>
@if (open) {
  <div class="msw-panel">
    <div class="msw-tabs">
      <button type="button" (click)="tab = 'requests'" [class.active]="tab === 'requests'">Requests</button>
      <button type="button" (click)="tab = 'mocks'" [class.active]="tab === 'mocks'">Mocks</button>
    </div>

    @if (tab === 'requests') {
      <button type="button" (click)="clearLog()">Clear</button>
      <ul class="msw-list">
        @for (r of requests(); track r.id) {
          <li>
            <span class="m">{{ r.method }}</span>
            <span class="s">{{ r.status }}</span>
            <span class="o">{{ r.outcome }}</span>
            <span class="u">{{ r.url }}</span>
            <button type="button" (click)="mockThis(r)">Mock this</button>
          </li>
        }
      </ul>
    }

    @if (tab === 'mocks') {
      <form class="msw-form" (ngSubmit)="saveMock()">
        <label class="msw-field">
          <span class="msw-label">Method</span>
          <select name="method" [(ngModel)]="fMethod">
            <option value="get">GET</option>
            <option value="post">POST</option>
            <option value="put">PUT</option>
            <option value="delete">DELETE</option>
            <option value="patch">PATCH</option>
            <option value="all">ALL</option>
          </select>
        </label>
        <label class="msw-field">
          <span class="msw-label">URL pattern</span>
          <input name="url" [(ngModel)]="fUrl" placeholder="*/api/..." />
        </label>
        <label class="msw-field">
          <span class="msw-label">Response status</span>
          <input name="status" type="number" [(ngModel)]="fStatus" />
        </label>
        <label class="msw-field">
          <span class="msw-label">Delay (ms)</span>
          <input name="delay" type="number" [(ngModel)]="fDelay" placeholder="0" />
        </label>
        <label class="msw-field">
          <span class="msw-label">Response body (JSON)</span>
          <textarea name="body" [(ngModel)]="fBody" rows="6"></textarea>
        </label>
        @if (jsonError) {
          <p class="msw-error">{{ jsonError }}</p>
        }
        <button type="submit">Save mock</button>
      </form>
      <ul class="msw-list">
        @for (m of mocks(); track m.id) {
          <li>
            <input type="checkbox" aria-label="{{ m.method }} {{ m.urlPattern }}" [checked]="m.enabled" (change)="toggle(m.id)" />
            <span class="m">{{ m.method }}</span>
            <span class="s">{{ m.status }}</span>
            <span class="u">{{ m.urlPattern }}</span>
            <button type="button" (click)="remove(m.id)">x</button>
          </li>
        }
      </ul>
    }
  </div>
}
